export function toRoman(num) {
  if (!num || num < 1) return '';

  const table = [
    [1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'],
    [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'],
    [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I'],
  ];

  let n = num;
  let result = '';
  for (const [value, numeral] of table) {
    while (n >= value) {
      result += numeral;
      n -= value;
    }
  }
  return result;
}